export const howItWorksData = [
  {
    title: "Fill Out the Form",
    details: [
      "Choose Your Preferred Time",
      "Discuss Your Fleet Objectives",
      "Receive Tailored Advice",
    ],
    description:
      "This step ensures that we have a comprehensive understanding of your needs before moving forward.",
  },
  {
    title: "Schedule Your Personalized Consultation",
    details: [
      "Confirm Your Appointment",
      "Detail Your Fleet Objectives",
      "Get Customized Recommendations",
    ],
    description:
      "This step ensures that we have a comprehensive understanding of your needs before moving forward.",
  },
  {
    title: "Prepare for Your Test Drive",
    details: [
      "Select Test Drive Duration",
      "Install with Assistance",
      "Begin Your Trial",
    ],
    description:
      "This step prepares you for a hands-on experience with Trackmate's capabilities within your fleet's real-world environment.",
  },
  {
    title: "Experience Trackmate in Action",
    details: [
      "Activate and Monitor",
      "Access Support Anytime",
      "Review Performance",
    ],
    description:
      "Throughout the test drive period, our support team will be available to assist and answer any questions you may have.",
  },
  {
    title: " Make an Informed Decision",
    details: [
      "Receive Your Discount",
      "Evaluate the Results",
      "Ongoing Support",
    ],
    description:
      "You have taken advantage of the benefits of Fleet Inquire. Now you can trust us",
  },
];
